import React from 'react';

const DataTableElement = ({ columns, items, tableLoad, classHead = '' }) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full w-full text-left">
        {/* Head */}
        <thead
          className={`
            bg-cs-bg-alt/80
            text-[10px] md:text-[11px]
            font-medium
            text-cs-muted
            border-b border-cs-border
            uppercase tracking-wide
            ${classHead}
          `}
        >
          <tr>
            {columns.map((col) => (
              <th key={col.id} className="px-3 py-3">
                {col.name}
              </th>
            ))}
          </tr>
        </thead>

        {/* Body */}
        <tbody className="bg-cs-bg text-cs-dark text-xs md:text-sm">
          {tableLoad.show ? (
            // Loading state
            <tr>
              <td colSpan={columns.length} className="px-4 py-8 text-center">
                <div className="flex flex-col items-center justify-center gap-3">
                  <div className="relative flex items-center justify-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-3 border-cs-primary border-t-transparent opacity-80" />
                  </div>
                  <span className="text-[11px] text-cs-muted">
                    {tableLoad.textLoad ?? 'Loading...'}
                  </span>
                </div>
              </td>
            </tr>
          ) : items && items.length ? (
            // Data rows
            items.map((item) => (
              <tr
                key={item.id}
                className="
                  border-b border-cs-border/70
                  hover:bg-cs-primary-soft/40
                  transition-colors
                "
              >
                {columns.map((col) => (
                  <td key={col.id} className="px-3 py-3 align-middle">
                    {col.cell ? col.cell(item) : col.selector?.(item)}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            // Empty state
            <tr>
              <td colSpan={columns.length} className="px-4 py-10 text-center">
                <div className="flex flex-col items-center justify-center gap-2">
                  <span className="material-symbols-outlined text-3xl text-cs-muted/40">
                    table_rows
                  </span>
                  <span className="text-[11px] md:text-sm text-cs-muted">
                    No items found to display.
                  </span>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTableElement;
